import { render } from "./Applications.vue?vue&type=template&id=5bb4d9ef&scoped=true"
import script from "./Applications.vue?vue&type=script&lang=js"
export * from "./Applications.vue?vue&type=script&lang=js"

import "./Applications.vue?vue&type=style&index=0&id=5bb4d9ef&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb4d9ef"]])

export default __exports__